export default {"src":"/_next/static/media/plan-icon-flower-pink.d78f58e4.svg","height":31,"width":30,"blurWidth":0,"blurHeight":0};